// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__35OfN","option":"styles_option__1Pmk1","active":"styles_active__1szjV"};